import React from 'react';


const TDDEnergyInfo = () => {
    return (
        <div className="container"> 
            <div className="row">
                <div className="col-lg-6">
                    <h2>About Us</h2>
                    <p>Welcome to TDDEnergy, your partner in sustainable energy solutions. We are dedicated to providing clean, reliable, and affordable energy to homes and businesses.</p>
                </div>
                <div className="col-lg-6">
                    <img src="path/to/your/image.jpg" alt="TDDEnergy" className="img-fluid" />
                </div>
            </div>
        </div>
    );
};

export default TDDEnergyInfo;   

